require('./cardBoxLastMovementsTableRow.scss');

const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const { Link } = require('react-router-dom');
// @ helpers
const { getLanguage, formatText } = require('core/i18n').i18n;
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');
//@ utilities
const { cardValidationRules } = require('utilities/accessHelperConditions/cards');
const { getCategoryIconURL } = require('utilities/expensesByCategories/categoriesUtilities');
const { getCategoryIcon } = require('constants/categories');
const { recordLink } = require('utilities/tagging');

// @ components
const { LabelDate } = require('commonsComponents/labelDate');
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const WebappRender = require('components/conditionalRender/webappRender')
const ContactCenterRender = require('components/conditionalRender/contactCenterRender')
const TruncateText = require('components/commons/truncateText/truncateText');
// @ commons
const { OKIconCategorization } = require('commonsComponents/OKIconCategorization');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const OKTag = require('components/commons/OKTag/OKTag');
const { CARD_CREDIT, HYPHEN, CARD_DEFERRED_PAYMENT, CARD_DEFERRABLE_PAYMENT, CARD_NOT_DEFERRABLE_PAYMENT } = require('constants/index');
// @ constants
const { LABEL_DATE_TODAY, LABEL_DATE_YESTERDAY } = require('constants/commonsComponents');
const { LAVANDA, PFM_NEW_FEATURES } = require('constants/flagBasedFeatures');
const { DEFERRAL_PAYMENT_CARD_ACTION_EVENT, DEFERRAL_PAYMENT_CLICK_TAG_ACTION_EVENT } = require('constants/tagging');

class CardBoxLastMovementsTableRow extends React.Component {
    constructor(props) {
        super(props);
        this.handleRowClick = this.handleRowClick.bind(this);
    }

    buildPurchaseDeferralSection(immCard) {
        const { flagBasedFeatures, immTransaction } = this.props;
        const deferPaymentType = immTransaction.get('deferPaymentIndicator');
        const cardId = immTransaction.get('cardId');
        const transactionId = immTransaction.get('id');
        let tag = HYPHEN;

        switch (deferPaymentType) {
            case CARD_DEFERRABLE_PAYMENT:
                if (cardValidationRules.CARD_PAYMENT_PURCHASE_DEFERRAL.validator({ immCard })) {
                    tag = (
                        <Link
                            onClick={() => flagBasedFeatures.get(LAVANDA) && recordLink(window.utag_last_name, DEFERRAL_PAYMENT_CARD_ACTION_EVENT, DEFERRAL_PAYMENT_CLICK_TAG_ACTION_EVENT)}
                            to={
                                '/myprofile/cards/' +
                                cardId +
                                '/payment-purchase-deferral/' +
                                transactionId
                            }
                        >
                            <OKTag content="cardsTransactions-defer" type="action" />
                        </Link>
                    );
                }
                break;
            case CARD_DEFERRED_PAYMENT:
                tag = <OKTag content="cardsTransactions-deferred" type="disabled"/>;
                break;
            case CARD_NOT_DEFERRABLE_PAYMENT:
            default:
                tag = HYPHEN;
                break;
        }

        return (
            <OKTableCell className="card-box-last-movements-table-row__cell-deferrable">
                {tag}
            </OKTableCell>
        );
    }

    handleRowClick() {
        const { id, onRowClick } = this.props;

        onRowClick(id);
    }

    render() {
        const { immTransaction, id, immCards, flagBasedFeatures } = this.props;
        const NEW_PFM_FEATURES = flagBasedFeatures.get(PFM_NEW_FEATURES)
        const cardId = immTransaction.get('cardId');
        const immCard = immCards.get('byId').get(cardId);
        let descriptionCharLimit = 32;
        const plainAmountObject = getPlainAmountObject(immTransaction.get('import'));
        const category = immTransaction.get('category');
        const categoryIcon = NEW_PFM_FEATURES ? getCategoryIconURL(category): getCategoryIcon(category);
        const language = getLanguage();
        let categoryTooltip, purchaseDeferralSection;
        let categoryText;

        if (category) {
            categoryText = formatText(NEW_PFM_FEATURES ? `categorized-${category}` : `categories-${category}`);
        }

        if (immCard.get('type') === CARD_CREDIT) {
            purchaseDeferralSection = this.buildPurchaseDeferralSection(immCard);
            descriptionCharLimit = 12;
        }

        const okCategoryIcon = (
            <span>
                <OKIconCategorization iconUrl={NEW_PFM_FEATURES ? categoryIcon : null} icon={categoryIcon}/>
            </span>
        );

        if (category) {
            categoryTooltip = (
                <OKTooltip
                    content={categoryText}
                    offset={[0, -30]}
                    target={okCategoryIcon}
                    type="descriptive"
                />
            );
        }

        const description = immTransaction.get('description')

        return (
            <OKTableRow id={id} onClick={this.handleRowClick}>
                <OKTableCell className="card-box-last-movements-table-row__cell-date">
                    <LabelDate
                        date={immTransaction.get('date')}
                        language={language}
                        today={LABEL_DATE_TODAY}
                        yesterday={LABEL_DATE_YESTERDAY}
                    />
                </OKTableCell>
                <OKTableCell className="card-box-last-movements-table-row__cell-category">
                    {categoryTooltip}
                </OKTableCell>
                <OKTableCell className="card-box-last-movements-table-row__cell-description">
                    <p className="card-box-last-movements-table-row__cell-description-content">
                        <WebappRender>
                            {description}
                        </WebappRender>
                        <ContactCenterRender>
                            <OKTooltip
                                content={description}
                                target={
                                    <span>
                                        <TruncateText
                                            str={description}
                                            charLimit={descriptionCharLimit}
                                            lineAmount={2}
                                        />
                                    </span>
                                }
                                />
                        </ContactCenterRender>
                    </p>
                </OKTableCell>
                {purchaseDeferralSection}
                <OKTableCell className="card-box-last-movements-table-row__cell-import">
                    <OneLineSymbolAmount
                        amountObject={plainAmountObject}
                        language={language}
                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)} />
                </OKTableCell>
            </OKTableRow>
        );
    }
}

CardBoxLastMovementsTableRow.propTypes = {
    immTransaction: PropTypes.object,
    id: PropTypes.string,
    onRowClick: PropTypes.func,
    immCards: PropTypes.object,
    flagBasedFeatures: PropTypes.object,
};

CardBoxLastMovementsTableRow.defaultProps = {
    onRowClick: function () { }
};

module.exports = connect(state => ({
    immCards: state.cards,
    flagBasedFeatures: state.flagBasedFeatures
}))(CardBoxLastMovementsTableRow);
